import React from 'react';
import { Switch, Route } from 'react-router-dom';
import TransitionManager from './TransitionManager';

const animateSwitch = (CustomSwitch, AnimatorComponent) => ({ updateStep, children }) => (
  <Route
    render={({ location }) => (
      <AnimatorComponent uniqKey={location.pathname} updateStep={updateStep}>
        <CustomSwitch location={location}>{children}</CustomSwitch>
      </AnimatorComponent>
    )}
  />
);

const RouterAnimation = animateSwitch(Switch, TransitionManager);
export default RouterAnimation;



// WEBPACK FOOTER //
// ./src/components/RouterAnimation/RouterAnimation.js